module.exports = __webpack_public_path__ + "static/img/img_title_08.fc8a910.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/img_title_08.png
// module id = 559
// module chunks = 1